import BondedLoan from 'components/BondedLoan/Index'
import Investors from 'components/BondedLoan/Investors'
import Investor from 'components/BondedLoan/investorComponents/Investor'

export default {
  children: [
    {
      path: 'bonded-loan',
      name: 'BondedLoan',
      component: BondedLoan
    },
    {
      path: 'investor-emitent',
      name: 'Investors',
      component: Investors,
      children: [
        {
          path: ':id',
          name: 'Investor',
          component: Investor
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/LoanRoutes.js